<template>
    <v-card style="margin: 2% 0 5% 0">
        <v-card-title
            style="font-size: 16px; background-color: #009688; font-weight: 600;"
            class="white--text"
        >
            Approval No.: {{ acuData.membInfo.OPAN_N }}
            <v-spacer />
            <v-btn
                :disabled="loading"
                small
                color="success"
                @click="handleRevalidate"
            >
                <v-icon small>
                    {{ mdiRefresh }}
                </v-icon>&nbsp;revalidate
            </v-btn>
            &nbsp;
            <v-btn
                :loading="loading"
                color="primary"
                small
                class="white--text"
                @click="handleDownloadOpan({ OPAN_N: acuData.membInfo.OPAN_N })"
            >
                <v-icon small>
                    {{ mdiDownload }}
                </v-icon>&nbsp;download
            </v-btn>
        </v-card-title>
        <v-card-text style="color: #111;">
            <div style="border-radius: 5px; margin: 15px 5px; padding: 1px;" class="elevation-2">
                <h1 style="font-size: 20px; margin: 18px 15px;">
                    {{ acuData.membInfo.LAST_M }}
                </h1>
                <v-row style="margin: 0 15px 15px 15px; border-top: 1px solid gray;">
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Birthdate:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.BIRT_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Age:</span> <span class="membInfoText">{{ acuData.membInfo.AGE }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Gender.:</span> <span class="membInfoText">{{ acuData.membInfo.SEX }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Account No.:</span> <span class="membInfoText">{{ acuData.membInfo.ACCT_N }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Account Name.:</span> <span class="membInfoText">{{ acuData.membInfo.ACCT_M }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Member No.:</span> <span class="membInfoText">{{ acuData.membInfo.MEMB_N }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Approve Date:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.APPR_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Valid Until:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.VALI_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Hospital/Clinic Name:</span> <span class="membInfoText">{{ acuData.membInfo.MSUU_N }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">MSU Code:</span> <span class="membInfoText">{{ acuData.membInfo.MSUU_C }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Issued By:</span> <span class="membInfoText">{{ acuData.membInfo.ISSU_N }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Issued Date:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.ISSU_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Membership Status:</span> <span class="membInfoText">{{ acuData.membInfo.STTS_C }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Account Expiry:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.AEXP_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Member Expiry:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.LAST_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Paid Until:</span> <span class="membInfoText">{{ formatDate(acuData.membInfo.PDUN_D) }}</span>
                    </v-col>
                    <v-col cols="12" md="6" style="border-bottom: 1px solid gray; padding: 10px 0;">
                        <span class="membInfoLabel">Grace Period:</span> <span class="membInfoText">{{ acuData.membInfo.GRACE_D ? formatDate(acuData.membInfo.GRACE_D) : 'None' }}</span>
                    </v-col>
                </v-row>
            </div>
            <div style="border-radius: 5px; border: 1px solid #eee; margin: 20px 5px" class="elevation-2">
                <div style="background-color: #f5f5f5; padding: 1px 0;">
                    <label style="position: relative;">
                        <span style="position: absolute; left: 17px; top: 20px;">Remarks:</span>
                        <v-textarea
                            ref="autoScrollTextarea1"
                            v-model="acuData.membInfo.REMA"
                            color="gray"
                            class="custom-scroll-revalidate"
                            style="margin: 45px 15px 20px 15px; max-height: 200px; overflow-y: auto !important;"
                            auto-grow
                            rows="1"
                            row-height="2"
                            hide-details
                            dense
                            readonly
                            outlined
                        />
                    </label>
                </div>
                <div style="background-color: #fff; padding: 1px 0;">
                    <label style="position: relative;">
                        <span style="position: absolute; left: 17px; top: 20px;">Internal Remarks:</span>
                        <v-textarea
                            ref="autoScrollTextarea2"
                            v-model="acuData.membInfo.INTREM"
                            color="gray"
                            class="custom-scroll-revalidate"
                            style="margin: 45px 15px 20px 15px; max-height: 200px; overflow-y: auto !important;"
                            auto-grow
                            outlined
                            rows="1"
                            row-height="2"
                            hide-details
                            dense
                            readonly
                        />
                    </label>
                </div>
                <div style="background-color: #f5f5f5; padding: 1px 0;">
                    <label style="position: relative;">
                        <span style="position: absolute; left: 17px; top: 20px;">History:</span>
                        <v-textarea
                            ref="autoScrollTextarea3"
                            v-model="acuData.membInfo.HISTORY"
                            color="gray"
                            class="custom-scroll-revalidate"
                            style="margin: 45px 15px 20px 15px; max-height: 200px; overflow-y: auto;"
                            auto-grow
                            outlined
                            rows="1"
                            row-height="2"
                            hide-details
                            dense
                            readonly
                        />
                    </label>
                </div>
            </div>
            <v-data-table
                :items="acuData.diagnostics"
                :headers="headers"
                :items-per-page="-1"
                hide-default-footer
                style="margin: 10px 5px"
                class="elevation-2"
            >
                <template #top>
                    <p style="font-size: 16px; padding: 15px 15px 0 15px;">
                        Medical Procedures
                    </p>
                </template>
                <template #[`item.VERIFIED`]="{ item }">
                    <v-icon :color="item.VERIFIED === 'YES' ? 'green' : 'red'">
                        {{ item.VERIFIED === "YES" ? mdiCheckboxMarked : mdiClose }}
                    </v-icon>
                </template>
                <template #[`item.DONE`]="{ item }">
                    <v-icon :color="item.DONE === 'YES' ? 'green' : 'red'">
                        {{ item.DONE === "YES" ? mdiCheckboxMarked : mdiClose }}
                    </v-icon>
                </template>
                <template #[`item.PICU_N`]="{ item }">
                    <span style="text-wrap: nowrap;">{{ item.PICU_N ? item.PICU_N : '-' }}</span>
                </template>
                <template #[`item.VERI_D`]="{ item }">
                    <span style="text-wrap: nowrap;">{{ item.VERI_D ? formatDateTimestamp(item.VERI_D) : '-' }}</span>
                </template>
                <template #[`item.DONE_PIC`]="{ item }">
                    <span style="text-wrap: nowrap;">{{ item.DONE_PIC ? item.DONE_PIC : '-' }}</span>
                </template>
                <template #[`item.DONE_TIMESTAMP`]="{ item }">
                    <span style="text-wrap: nowrap;">{{ item.DONE_TIMESTAMP ? formatDateTimestamp(item.DONE_TIMESTAMP) : '-' }}</span>
                </template>
                <template #[`item.DET`]="{ item }">
                    <ul v-if="isDetArray(item.DET)" style="list-style-type: none; padding-left: 0;">
                        <li v-for="(det, key) in item.DET.split(';')" :key="key" style="text-wrap: nowrap;">
                            {{ det }}
                        </li>
                    </ul>
                    <span v-else>{{ item.DET }}</span>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import { saveAs } from 'file-saver'
import { mapGetters, mapActions } from 'vuex'
import {
    mdiRefresh,
    mdiDownload,
    mdiCheckboxMarked,
    mdiClose
} from '@mdi/js'
import { base64ToBlob } from '../../../../utils/helpers'
import { moment } from '../../../../utils/date-shim'
export default {
    props: ['acuData', 'notif', 'isRevalidateOnProcess', 'validityDays'],
    data: ()=>({
        mdiRefresh,
        mdiDownload,
        mdiCheckboxMarked,
        mdiClose,
        loading: false,
        headers: [
            { text: 'No.', value: 'OID', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Procedure', value: 'DET', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Is Verified?', value: 'VERIFIED', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Is Done?', value: 'DONE', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Verified By', value: 'PICU_N', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Verified On', value: 'VERI_D', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Done By', value: 'DONE_PIC', class: 'acuAdminRevalidateMedicalProcedure' },
            { text: 'Done On', value: 'DONE_TIMESTAMP', class: 'acuAdminRevalidateMedicalProcedure' }
        ],
        screen_width: document.documentElement.clientWidth + 9,
        remarksHeight: 500
    }),
    computed: {
        ...mapGetters(['revalidateAcuApprovalData', 'downloadAcuApprovalData', 'fetchAcuApprovalData'])
    },
    watch: {
        'acuData.membInfo.REMA'() {
            this.$nextTick(() => {
                const wrapper = this.$refs.autoScrollTextarea1
                if (wrapper && wrapper.$el) {
                    const textarea = wrapper.$el.querySelector('textarea')
                    if (textarea && textarea.scrollHeight > 500) {
                        textarea.scrollTop = textarea.scrollHeight
                    }
                }
            })
        },
        'acuData.membInfo.INTREM'() {
            this.$nextTick(() => {
                const wrapper = this.$refs.autoScrollTextarea2
                if (wrapper && wrapper.$el) {
                    const textarea = wrapper.$el.querySelector('textarea')
                    if (textarea && textarea.scrollHeight > 500) {
                        textarea.scrollTop = textarea.scrollHeight
                    }
                }
            })
        },
        'acuData.membInfo.HISTORY'() {
            this.$nextTick(() => {
                const wrapper = this.$refs.autoScrollTextarea3
                if (wrapper && wrapper.$el) {
                    const textarea = wrapper.$el.querySelector('textarea')
                    if (textarea && textarea.scrollHeight > 500) {
                        textarea.scrollTop = textarea.scrollHeight
                    }
                }
            })
        },
        isRevalidateOnProcess(newVal) {
            if (newVal) {
                this.revalidateAcuApproval({ MEMB_N: this.acuData.membInfo.MEMB_N, OPAN_N: this.acuData.membInfo.OPAN_N, VALI_D: this.validityDays })
            }
        },
        fetchAcuApprovalData(newVal) {
            if (newVal && newVal.status === 200) {
                this.$emit('isAcuHasResult', newVal)
            }
        },
        downloadAcuApprovalData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Download Complete!'
                    this.notif.show = true
                    this.handleFileDownload(newVal.data, `${this.acuData.membInfo.OPAN_N}-${this.acuData.membInfo.MEMB_N}.pdf`)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        },
        revalidateAcuApprovalData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    const params = {
                        MSUU_C: this.$cookies.get('provider_id'),
                        OPAN_N: this.acuData.membInfo.OPAN_N,
                        MEMB_N: this.acuData.membInfo.MEMB_N
                    }
                    this.fetchAcuApproval(params)
                } else {
                    this.$emit('isAcuHasResult', newVal)
                }
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        // this.getCsrfToken()
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['revalidateAcuApproval', 'getCsrfToken', 'downloadAcuApproval', 'fetchAcuApproval']),
        isDetArray(det) {
            if (det) {
                const detCount = det.split(';')
                return detCount.length > 1
            }
            return false
        },
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data.file,  data.type)
                const url = URL.createObjectURL(blob)
                saveAs(blob, fileName)
                URL.revokeObjectURL(url) // Clean up the URL object
            } catch (err) {
                // console.error('err: ', err)
            }
        },
        handleDownloadOpan(opanNumber) {
            this.loading = true
            this.downloadAcuApproval(opanNumber)
        },
        formatDateTimestamp(date) {
            return moment(date).format('MMMM D, YYYY hh:mm:ss A')
        },
        formatDate(date) {
            return moment(date).format('MMMM D, YYYY')
        },
        handleRevalidate() {
            this.$emit('confirmRevalidate')
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.custom-scroll-revalidate {
  overflow-y: auto !important;
  max-height: 200px;
}

.custom-scroll-revalidate::-webkit-scrollbar {
  width: 8px;
}

.custom-scroll-revalidate::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.custom-scroll-revalidate::-webkit-scrollbar-thumb {
  background-color: #00BA95;
  border-radius: 4px;
}

.custom-scroll-revalidate::-webkit-scrollbar-thumb:hover {
  background-color: #00796b;
}
.membInfoLabel {
    display: block;
    color: #666;
}
.membInfoText {
    color: #333;
    font-size: 16px;
}
.acuAdminRevalidateMedicalProcedure {
    background-color: #eee;
    border-bottom: 2px solid black;
}
</style>
